import { render, staticRenderFns } from "./accreditation-summary-report.vue?vue&type=template&id=c2237446&scoped=true"
import script from "./accreditation-summary-report.vue?vue&type=script&lang=js"
export * from "./accreditation-summary-report.vue?vue&type=script&lang=js"
import style0 from "./accreditation-summary-report.vue?vue&type=style&index=0&id=c2237446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2237446",
  null
  
)

export default component.exports